import { Dialog, DialogContent, Kbd } from '@/components/ui';
import { keyLabels, SHORTCUTS, type ShortcutDef } from '@/lib/keyboard';
import { useAppStore } from '@/lib/store';
import { BRAND } from '@/brand';

const GROUPS: readonly ShortcutDef['group'][] = ['General', 'Actions', 'Navigation', 'Register'];

/** Renders the global shortcut registry from `lib/keyboard.ts`, grouped. */
export const ShortcutsList = () => (
  <div className="grid gap-6 sm:grid-cols-2">
    {GROUPS.map((g) => (
      <section key={g} aria-labelledby={`sc-${g}`}>
        <h3 id={`sc-${g}`} className="mb-2 text-sm font-semibold text-text">
          {g}
        </h3>
        <dl className="flex flex-col gap-1">
          {SHORTCUTS.filter((s) => s.group === g).map((s) => (
            <div key={s.id} className="flex min-h-9 items-center justify-between gap-4 text-sm">
              <dt className="text-text-muted">{s.description}</dt>
              <dd className="flex items-center gap-1">
                {keyLabels(s.keys).map((step, i) => (
                  <span key={i} className="flex items-center gap-0.5">
                    {i > 0 ? <span className="px-0.5 text-xs text-text-muted">then</span> : null}
                    {step.map((k) => (
                      <Kbd key={k}>{k}</Kbd>
                    ))}
                  </span>
                ))}
              </dd>
            </div>
          ))}
        </dl>
      </section>
    ))}
  </div>
);

export const ShortcutsDialog = () => {
  const open = useAppStore((s) => s.shortcutsOpen);
  const set = useAppStore((s) => s.set);
  return (
    <Dialog open={open} onOpenChange={(o) => set({ shortcutsOpen: o })}>
      <DialogContent title="Keyboard shortcuts" description={`${BRAND.name} is built to be driven from the keyboard.`} size="lg">
        <ShortcutsList />
      </DialogContent>
    </Dialog>
  );
};
